<template>
  <div class="empty-components">
    <div v-if="isDiscount" class="wrap">
      <img :src="images" alt="">
      <p>尚无优惠，现在来 <router-link to="/discounts">申请</router-link> 一个吧</p>
    </div>
    <div v-if="!isDiscount" class="wrap">
      <p class="empty">{{describe}}</p>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
  export default {
    name: 'empty',
    props: {
      isDiscount:{
        type: Boolean,
        default: false,
      },
      describe: {
        type:String,
        default: '暂无相关数据 !'
      }
    },
    data() {
      return {
        images: require('./empty.png')
      }
    },

  };
</script>

<style scoped lang="scss">
@import '../../../style/variable.scss';

.empty-components{padding: 80px 0;
  .wrap{text-align: center;
    img{width: 86px;height: 56px}
    p{font-size:12px;color:#979797;padding: 15px;
      a{color: red;text-decoration: underline}
    }
    .empty{font-size:14px;color:#979797;padding: 15px;}
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build901/components/common/empty/empty.vue